import { DateTime } from "luxon";

export function getDateRangeString(startDate: DateTime, endDate: DateTime) {
  if (startDate.hasSame(endDate, "day")) {
    return startDate.toLocaleString(DateTime.DATE_SHORT);
  }
  return `${startDate.toLocaleString(DateTime.DATE_SHORT)} - ${endDate.toLocaleString(DateTime.DATE_SHORT)}`;
}
